import { ReactNode } from 'react';
import { Mui } from '@leap4/frontend';

const { Box, Typography } = Mui;

/** One filter or constraint: a quiet bordered row, stacking on narrow screens. */
export const rowSx = {
    display: 'grid',
    gap: 1,
    alignItems: 'center',
    p: 1,
    border: 1,
    borderColor: 'divider',
    borderRadius: '10px',
    bgcolor: 'background.default',
};

export const EmptyRow = ({ text, action }: { text: string; action: ReactNode }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', px: 1.5, py: 1, border: 1, borderStyle: 'dashed', borderColor: 'divider', borderRadius: '10px' }}>
        <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 180 }}>
            {text}
        </Typography>
        {action}
    </Box>
);
